import React from "react";
import { Form } from "react-bootstrap";

export const InputError = ({ meta, children, className, showError }) => {
  const errorMessage = meta && meta.error && (meta.touched || showError) ? meta.error : children;
  if (errorMessage) {
    return (
      <Form.Control.Feedback type="invalid" className={(className ? className : "") + " f-small"}>
        {errorMessage}
      </Form.Control.Feedback>
    );
  }
};
